(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/views/suspensionhistory-list.js') >= 0) return;  svs.modules.push('/modules/spelpaus/views/suspensionhistory-list.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.spelpaus=_svs.spelpaus||{};
_svs.spelpaus.templates=_svs.spelpaus.templates||{};
svs.spelpaus.templates.suspensionhistory_list = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["components-app-serversidehelper-render"],depth0,{"name":"components-app-serversidehelper-render","hash":{"childViewTag":"tr","collection":(depth0 != null ? depth0.suspensionHistory : depth0),"view":"suspensionhistoryitem"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['svs-spelpaus-suspensionhistory_list'] = svs.spelpaus.templates.suspensionhistory_list;
})(svs, Handlebars);

 })(window);